<template>
  <div class="card-slider">
    <Heading
      v-if="title && titleContent"
      :content="titleContent"
      size="large"
      tag="h2"
      role="headline"
      :align="titleAlignment"
    />
    <div class="card-slider__container">
      <div class="swiper-wrap">
        <swiper-container navigation="true" pagination="true" init="false">
          <swiper-slide v-for="(item, index) in slides" :key="index">
            <CardSliderItem v-bind="item" :aspectRatio="aspectRatio" />
          </swiper-slide>
        </swiper-container>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import './CardSlider.scss';
import { onMounted } from 'vue';
import Heading from 'ewi-ui/components/1-atoms/Heading';
import CardSliderItem from 'ewi-ui/components/2-molecules/CardSliderItem';
import CardSlider from './CardSlider';
import { CardSliderItemInterface } from 'ewi-ui/components/2-molecules/CardSliderItem/CardSliderItem.vue';
import { AspectRatio } from 'ewi-ui-helpers/types';

export interface CardSliderProps {
  title?: boolean;
  titleContent?: string;
  titleAlignment?: 'center' | 'left' | 'right' | '';
  slides?: CardSliderItemInterface[];
  aspectRatio?: '' | AspectRatio;
}

withDefaults(defineProps<CardSliderProps>(), {
  title: true,
  titleContent: 'Title',
  titleAlignment: 'center',
  slides: () => [],
});

onMounted(() => {
  CardSlider.init();
});
</script>
